import styled from '@emotion/styled'

import { Color } from '../constants'
import { Intent, getIntentProps } from '../constants/intent'
import { Div, DivProps } from '../elements/Div'
import { Icon, IconDesign, IconName, IconSize } from '../elements/Icon'
import { Tooltip } from '../elements/Tooltip'

const TooltipIconAnchor = styled(Div)({
  width: 'fit-content',
})

type TooltipIconPropsWithIntent = {
  iconName?: IconName
  tooltipIntent: Intent
  text: string
}

type TooltipIconPropsWithoutText = {
  iconName: IconName
  tooltipIntent?: never
  text: string
}

export type TooltipIconProps = (
  | TooltipIconPropsWithIntent
  | TooltipIconPropsWithoutText
) &
  DivProps & {
    className?: string
    color?: Color
    backgroundColor?: Color
    size?: IconSize
    design?: IconDesign
  }

export const TooltipIcon = ({
  text,
  tooltipIntent,
  color,
  backgroundColor,
  iconName,
  size,
  design,
  ...divProps
}: TooltipIconProps) => {
  const {
    backgroundColor: intentBackgroundColor,
    iconName: intentIconName,
    color: intentColor,
  } = getIntentProps(tooltipIntent ?? 'info')

  return (
    <Tooltip text={text} intent={tooltipIntent}>
      <Tooltip.Trigger asChild>
        <TooltipIconAnchor {...divProps}>
          <Icon
            name={iconName ?? intentIconName}
            color={color ?? intentColor}
            backgroundColor={backgroundColor ?? intentBackgroundColor}
            size={size}
            design={design}
          />
        </TooltipIconAnchor>
      </Tooltip.Trigger>
    </Tooltip>
  )
}
